import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "../../config/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with AeroVaid on WhatsApp"
    data-testid="whatsapp-float"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 200, damping: 15 }}
    className="fixed bottom-5 right-5 z-50 grid place-items-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
  >
    <MessageCircle className="w-7 h-7 text-white" />
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
  </motion.a>
);
